import { urlApiCourse } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBaseResponse, IListDataResponseCanvas } from '~/utils/interface/base';
import {
  IModule,
  ICoursesDetail,
  IQueryGetCoursesOfStudent,
  ICourseSelect,
  IPayloadGetModulesOfCourse,
  IModuleSelect,
  ICourse,
  IQueryGetCourses,
  IPayloadUpdateCourses,
  IPayloadGetCoursesDetailOfStudent,
  IPayloadGetDiscussionsOfCourse,
  IDiscussionTopic,
  ICourseMaterials,
} from '~/utils/interface/course';

export const courseApi = {
  getCourses(params: IQueryGetCourses) {
    const { isMainPage, ...rest } = params;
    return axiosClient.get<IBaseResponse<IListDataResponseCanvas<ICourse[]>>>(urlApiCourse.base, { params: rest });
  },

  updateCourses(payload: IPayloadUpdateCourses) {
    return axiosClient.put<IBaseResponse<any>>(urlApiCourse.base, payload);
  },

  getCourseUpcoming() {
    const url = `${urlApiCourse.getCourseUpcoming}`;
    return axiosClient.get<IBaseResponse<IModule[]>>(url);
  },

  getDetailCourse(coursesId: string, lessonId: string) {
    const url = `${urlApiCourse.getDetail(coursesId, lessonId)}`;
    return axiosClient.get<IBaseResponse<ICoursesDetail>>(url);
  },

  getCoursesOfStudent(params: IQueryGetCoursesOfStudent) {
    const url = `${urlApiCourse.getCoursesOfStudent}`;
    return axiosClient.get<IBaseResponse<IListDataResponseCanvas<ICourseSelect[]>>>(url, { params });
  },

  getModulesOfCourse(params: IPayloadGetModulesOfCourse) {
    const url = `${urlApiCourse.getModulesOfCourse(params.courseId)}`;
    const { courseId, ...queryParams } = params;
    return axiosClient.get<IBaseResponse<IListDataResponseCanvas<IModuleSelect[]>>>(url, { params: queryParams });
  },

  getCourseMaterials() {
    return axiosClient.get<IBaseResponse<ICourseMaterials>>(urlApiCourse.getMaterials);
  },

  getDiscussionsOfCourse(params: IPayloadGetDiscussionsOfCourse) {
    const url = `${urlApiCourse.getDiscussionsOfCourse(params.courseId)}`;
    const { courseId, ...queryParams } = params;
    return axiosClient.get<IBaseResponse<IListDataResponseCanvas<IDiscussionTopic[]>>>(url, { params: queryParams });
  },

  getCoursesDetailOfStudent(payload: IPayloadGetCoursesDetailOfStudent) {
    return axiosClient.get(`/courses/${payload.studentId}`, { params: { reportType: payload.reportType } });
  },
};
